<nb-tabset class="reminder-notifications-popup" [ngClass]="{'fullSizeTab':fullSizeTab}" (changeTab)="changedTab($event)">

  <nb-tab id="scrollReminder"  tabTitle="Reminders ({{unreadReminderCount}})">
    <ngx-view-reminders  [fromViewPage]="false" [loader]="loader"></ngx-view-reminders>
  </nb-tab>

  <nb-tab id="scrollNotification" *ngIf="!hideNotification && !checkReminderRecord" tabTitle="Notifications ({{ unreadNotificationCount }})" (scroll)="scrollHandler('notification',$event)">
    <div [ngClass]="[notification.visibility == 'unread' ? 'unread': '',
    notification.visibility == 'read' ? 'read': '']"
      (click)="tdClick(notification,notification.resourceDetails.tableId, notification.resourceDetails.tableName, notification.resourceDetails.resourceId)"
      *ngFor="let notification of notificationList;let i = index" class="rem-not-block">
      <div class="rem-not-time">
        <span class="rem-title">{{notification?.resourceDetails?.resourceName}}</span>
        <span (click)="deleteNotification(notification,i);$event.stopPropagation()" class="material-icons-outlined txt-clr rem-close">close</span>
        <span class="rem-date">
          <span class="material-icons-outlined clock-icon">
            schedule
            </span>
            {{ formatDate(notification.createdAt)}}</span>
      </div>
      <div *ngIf="notification?.fieldType && (notification?.fieldType == 'dateTime' || notification?.fieldType == 'date'); else nonDateTime"  class="rem-not-text">
         {{ notification.sender.firstName + ' has changed ' + notification.fieldUpdated+ ' from '}} {{ notification.oldValue | dateCustomPipe }}  to {{ notification.newValue | dateCustomPipe }}
      </div>
      <ng-template #nonDateTime>
        <div class="rem-not-text">
          {{notification.text}}
        </div>
      </ng-template>

    </div>
    <div class="mt-4 text-center" *ngIf="reminderList?.length == 0">
          <Span>No data found</Span>
    </div>

    <div class="spinner-div">
      <span [nbSpinner]="loader" nbSpinnerSize="small" nbSpinnerStatus="primary"></span>
    </div>

  </nb-tab>

</nb-tabset>
